import React, { Component } from "react";
import { t, setLocale } from "../../helpers/translate";
import { setMicrositeColour } from "../../helpers/style";
import ModalComponent from "../common/ModalComponent";

import linkIcon from "../../Logos/MemberPortal/link-icon.svg";

require("styles/MemberPortal.scss");

import mshENLogo from "../../Logos/MSH-Square_EN.png";
import mshFRLogo from "../../Logos/MSH-Square_FR.png";
import FloatToTopButton from "../common/FloatToTopButton";
import AnnouncementFR from "./AnnouncementFR";
import AnnouncementEN from "./AnnouncementEN";

class MemberPortal extends Component {
  constructor(props) {
    setLocale(props.params.lang);
    setMicrositeColour(props.params.microsite);

    sessionStorage.setItem("hide_navbar", true);
    document.body.style.backgroundColor = "white";
    super(props);

    this.state = {
      policyNumber: "",
      hasError: false,
      errorMessage: null,
      showWalletCard: false,
      showPSHCPUpdateModal: false,
    };
  }

  renderModal(lang) {
    return lang === "en" ? <AnnouncementEN /> : <AnnouncementFR />;
  }

  renderFaqLink = (url, label) => (
    <a href={url} target="_blank" className="link">
      {t(label)}
      <img src={linkIcon} className="link-icon" />
    </a>
  );

  render() {
    const { lang } = this.props.params;
    const newLang = lang === "en" ? "fr" : "en";

    const links = {
      compClaimForm: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Comprehensive_claims_incurred_outside_of_Canada_claimform.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Demande_de_reglement_pour_frais_engages_a_lexterieur_du_Canada_au_titre_de_la_protection_totale.pdf",
      },
      suppClaimForm: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Emergency_benefit_while_travelling_claimform.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Demande_de_reglement_au_titre_de_la_garantie-voyage_durgence.pdf",
      },
      faq: {
        en: "https://www.welcome.canadalife.com/pshcp/msh/msh-member-update.html",
        fr: "https://www.bienvenue.canadavie.com/rssfp/msh/msh-mise-a-jour.html",
      },
      privacy: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Privacy_Disclaimer.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Protection_des_renseignements_personnels.pdf",
      },
      PSHCPMemberServiceWebsite: {
        en: "https://www.welcome.canadalife.com/pshcp",
        fr: "https://www.bienvenue.canadavie.com/rssfp",
      },
      publicServiceHealthCarePlan: {
        en: "https://www.pshcp.ca/",
        fr: "https://www.rssfp.ca/",
      },
      membersWithSuppCoverage: {
        en: "https://www.pshcp-msh.ca/a/eta",
        fr: "https://www.rssfp-msh.ca/a/eta",
      },
      membersWithCompCoverage: {
        en: "https://www.pshcp-msh.ca/a/comp",
        fr: "https://www.rssfp-msh.ca/a/comp",
      },
      leavingCanada: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Leaving_Canada_what_you_need_to_know_about_the_PSHCP.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Vous_quittez_le_Canada_ce_que_vous_devez_savoir_sur_le_RSSFP.pdf",
      },
    };

    return (
      <div className="member-portal">
        <a className="skip-to-content" href="#main-id">
          Skip to content
        </a>
        <div className="main-wrapper">
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light">
              <div className="container">
                <div className="navbar-brand">
                  <img
                    src={lang == "en" ? mshENLogo : mshFRLogo}
                    width="60"
                    height="60"
                    alt="MSH Canada"
                  />
                </div>
                <span
                  className="row-flex navbar-lang"
                  onClick={() => {
                    const member_portal_url_en = "https://pshcp-msh.ca";
                    const member_portal_url_fr = "https://rssfp-msh.ca";

                    if (location.hostname !== "dashboard.studyinsured.com") {
                      location.replace(`/msh/member_portal/${newLang}`);
                    } else {
                      parent.location.href = eval(
                        `member_portal_url_${newLang}`
                      );
                    }
                  }}
                >
                  {newLang.toUpperCase()}
                </span>
              </div>
            </nav>
          </div>

          <div className="info-banner">
            {t("Please note that due to mail that has accumulated during the postal disruption, there may be some delays in processing incoming paper claims and issuing reimbursements or other correspondence by mail. We appreciate your patience as we work quickly to return to business as usual.")}
          </div>

          <div className="container">
            <div className="row text-center">
              <h1 className="mp-h1">
                {t(
                  "Welcome to the MSH Public Service Health Care Plan (PSHCP) Member Portal"
                )}
              </h1>
              <h2 className="mp-h2">
                {t(
                  "MSH International (MSH) is your emergency travel assistance and Comprehensive Coverage provider for the Public Service Health Care Plan (PSHCP)."
                )}
              </h2>
            </div>
          </div>
        </div>

        <div className="container mp-box">
          <h2>{t("Log in or register for your account")}</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="mp-box-header">
                <h2 className="mp-box-title">
                  {t("Members with Supplementary Coverage")}
                </h2>
              </div>
              <div className="mp-box-body">
                <p className="mp-box-descprition">
                  ({t("Incurring emergency expenses while travelling")}):
                </p>
                <button
                  className="btn button-secondary mp-button"
                  tabIndex="0"
                  onClick={() => {
                    window.open(links.membersWithSuppCoverage[lang], "_blank");
                  }}
                >
                  <span className="row-flex">
                    {t("Log in or register")}
                    <div className="mp-arrow" />
                  </span>
                </button>
              </div>
            </div>
            <div className="vertical" />
            <div className="col-md-6">
              <div className="mp-box-header">
                <h2 className="mp-box-title">
                  {t("Members with Comprehensive Coverage")}
                </h2>
              </div>

              <div className="mp-box-body" id="main-id">
                <p className="mp-box-descprition">
                  (
                  {t(
                    "incurring expenses outside of Canada while posted, deployed, or living abroad"
                  )}
                  ):
                </p>
                <button
                  className="btn button-secondary mp-button"
                  onClick={() => {
                    window.open(links.membersWithCompCoverage[lang], "_blank");
                  }}
                >
                  <span className="row-flex">
                    {t("Log in or register")}
                    <div className="mp-arrow" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="center-children" style={{ padding: "0 30px" }}>
          <button
            className="btn button-secondary mp-button update-button"
            onClick={() => {
              this.setState({ showPSHCPUpdateModal: true });
            }}
          >
            {t("Update from MSH International to PSHCP members")}
          </button>
        </div>

        <div className="claims-info">
          <h2 className="title">{t("MSH processes the following claims")}: </h2>
          <ul>
            <li>
              {t(
                "Emergency Travel Assistance (ETA) claims for members with Supplementary Coverage"
              )}
            </li>
            <li>
              {t(
                "Claims for expenses incurred outside of Canada for members with Comprehensive Coverage"
              )}
            </li>
          </ul>

          <p>
            {t("All other claims should be submitted to")}
            <a
              href={links.PSHCPMemberServiceWebsite[lang]}
              target='_blank'
              className="link"
            >
              {t("Canada Life")}
              <img src={linkIcon} className="link-icon-img" />.
            </a>
          </p>
        </div>

        <div className="claims-form">
          <h2>{t("Claim Forms")}</h2>
          <div>
            {t("Supplementary Coverage")}:
            <a
              href={links.suppClaimForm[lang]}
              target='_blank'
              className="link"
            >
              <span className="link-text">
                {t("Emergency Benefit While Travelling Claim Form")}
                <img src={linkIcon} className="link-icon-img" />
              </span>
            </a>
          </div>

          <div>
            {t("Comprehensive Coverage")}:
            <a
              href={links.compClaimForm[lang]}
              target='_blank'
              className="link"
            >
              <span className="link-text">
                {t(
                  "Comprehensive Claims Incurred Outside of Canada Claim Form"
                )}
                <img src={linkIcon} className="link-icon-img" />
              </span>
            </a>
          </div>
        </div>

        <hr />

        <div className="contact center-children">
          <div className="row" style={{ width: "70vw" }}>
            <div className="col-md-7">
              <h2 className="title">{t("Contact us")}</h2>
              <div className="box">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="box-title">
                      <div className="phone-logo" />
                      {t("Phone")}
                    </h3>

                    <div className="box-content">
                      <div className="box-subtitle">
                        {t("NORTH AMERICA (Toll-free):")}
                      </div>
                      <div className="number">
                        <span>1-833-774-2700 (24/7)</span>
                        {lang === "en" && <span>(1-833-PSHCP-00)</span>}
                      </div>

                      <div className="box-subtitle">
                        {t("INTERNATIONAL (COLLECT):")}
                      </div>
                      <div className="number">
                        <span>1-365-337-7427 (24/7)</span>
                      </div>
                    </div>
                  </div>

                  <div className="box-divider" />

                  <div className="col-md-6">
                    <h3 className="box-title">
                      <div className="mail-logo" />
                      {t("Claims address")}
                    </h3>

                    <div className="box-content">
                      <div className="address-text">
                        <span>MSH International</span>
                        <span>{t("PO Box 4903, Stn A")}</span>
                        <span>Toronto, ON, M5W 0B1</span>
                        <span>Canada</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5">
              <h2 className="title">{t("Key Information")}</h2>
              <div className="box">
                <div className="box-content">
                  {this.renderFaqLink(links.faq[lang], "FAQ")}
                  {this.renderFaqLink(links.PSHCPMemberServiceWebsite[lang], "PSHCP Member Services website")}
                  {this.renderFaqLink(links.publicServiceHealthCarePlan[lang], "PSHCP Administration Authority")}
                  {this.renderFaqLink(links.leavingCanada[lang], "Leaving Canada what you need to know about the PSHCP")}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="left">
            <p>© MSH International (Canada) Ltd., 2023</p>
          </div>

          <div className="right">
            <a
              href={links.privacy[lang]}
              target='_blank'
            >
              {t("Privacy")}
              <div className="link-icon" />
            </a>
            <a
              href={links.faq[lang]}
              target='_blank'
            >
              {t("FAQ")}
              <div className="link-icon" />
            </a>
          </div>
        </div>
        <ModalComponent
          title={t("Update from MSH International to PSHCP members")}
          body={this.renderModal(lang)}
          onClose={this.setState.bind(this, { showPSHCPUpdateModal: false })}
          show={this.state.showPSHCPUpdateModal}
          resetDataOnClose={false}
          size="large"
        />
        <FloatToTopButton />
      </div>
    );
  }
}

MemberPortal.displayName = "Member Portal";
export default MemberPortal;



// WEBPACK FOOTER //
// ./src/components/MemberPortal/MemberPortal.js